(function(angular, jquery){
    'use strict';

    angular.module('bmFroala', ['froala', 'pascalprecht.translate', 'bluemoon.components.i18n'])
    .value('froalaConfig', {
        inlineMode: false,
        spellcheck: true,
        pasteImage: false,
        imageUpload: false,
        placeholder: '',
    })
    .factory('bmFroalaTranslate', ['$q', '$translate', '$rootScope', 'bmLanguageManager', function($q, $translate, $rootScope, bmLanguageManager){
        var factory = {
            initFroalaLanguages: loadFroalaLanguages,
            getLoadedLanguageAsync: getLoadedLanguageAsync
        };

        var froalaKeys = [
            'Bold',
            'Italic',
            'Underline',
            'Strikethrough',
            'Font Size',
            'Color',
            'Background',
            'Text',
            'Format Block',
            'Normal',
            'Paragraph',
            'Code',
            'Quote',
            'Heading 1',
            'Heading 2',
            'Heading 3',
            'Heading 4',
            'Heading 5',
            'Heading 6',
            'Block Style',
            'Alignment',
            'Align Left',
            'Align Center',
            'Align Right',
            'Justify',
            'Numbered List',
            'Bulleted List',
            'Indent Less',
            'Indent More',
            'Select All',
            'Insert Link',
            'Insert Image',
            'Insert Video',
            'Undo',
            'Redo',
            'Show HTML',
            'Float Left',
            'Float None',
            'Float Right',
            'Replace Image',
            'Remove Image',
            'Title',
            'Drop image',
            'or click',
            'or',
            'Enter URL',
            'Please wait!',
            'Are you sure? Image will be deleted.',
            'UNLINK',
            'Open in new tab',
            'Type something',
            'Cancel',
            'OK',
            'Manage images',
            'Delete',
            'Font Family',
            'Insert Horizontal Line',
            'Table',
            'Insert table',
            'Cell',
            'Row',
            'Column',
            'Delete table',
            'Insert cell before',
            'Insert cell after',
            'Delete cell',
            'Merge cells',
            'Horizontal split',
            'Vertical split',
            'Insert row above',
            'Insert row below',
            'Delete row',
            'Insert column before',
            'Insert column after',
            'Delete column',
            'Uploading image',
            'Upload File',
            'Drop File',
            'Clear formatting',
            'Insert Link Button',
            'Height',
            'Width',
            'Text Color',
            'Button Text',
            'http://example.com'
        ];

        // en_us already in froala.js
        var froalaDefault = 'en_us';

        // Load froala tooltip strings on any language change
        $rootScope.$on('bmLanguageChangeSuccess', function(){
            loadFroalaLanguages();
        });

        return factory;

        //////////

        function getLoadedLanguageAsync(){
            return bmLanguageManager.getLoadedLanguageAsync().then(function(language){
                return (language && language.code && language.code !== 'en-US') ? language.code : froalaDefault;
            }, function(){
                return froalaDefault;
            });
        }

        //////////

        function loadFroalaLanguages(){
            getLoadedLanguageAsync().then(function(code){
                // Defaults to button title definition from froala_editor.js
                if(code === froalaDefault){
                    return;
                }

                // TODO: DIRECTION MAY END UP NEEDING TO BE SET AT SOME POINT
                // Languages can be included as js references to bower-froala-editor/langs
                var lang = jQuery.Editable.LANGS[code];

                // Load custom translations if not using js references
                if(!lang){
                    lang = {
                        translation: {},
                        direction: 'ltr'
                    };

                    // must keep froalaKeys and promises in matching index order
                    $q.all(getTranslatePromises()).then(function(results){
                        for(var i = 0; i < results.length; i++){
                            lang.translation[froalaKeys[i]] = results[i];
                        }

                        // Add translations into froala list
                        jQuery.Editable.LANGS.push(code);
                        jQuery.Editable.LANGS[code] = lang;
                    });
                }
            });
        }

        function getTranslatePromises(){
           return [
                $translate('Bluemoon.Froala.Bold'),
                $translate('Bluemoon.Froala.Italic'),
                $translate('Bluemoon.Froala.Underline'),
                $translate('Bluemoon.Froala.Strikethrough'),
                $translate('Bluemoon.Froala.FontSize'),
                $translate('Bluemoon.Froala.Color'),
                $translate('Bluemoon.Froala.Background'),
                $translate('Bluemoon.Froala.Text'),
                $translate('Bluemoon.Froala.FormatBlock'),
                $translate('Bluemoon.Froala.Normal'),
                $translate('Bluemoon.Froala.Paragraph'),
                $translate('Bluemoon.Froala.Code'),
                $translate('Bluemoon.Froala.Quote'),
                $translate('Bluemoon.Froala.Heading1'),
                $translate('Bluemoon.Froala.Heading2'),
                $translate('Bluemoon.Froala.Heading3'),
                $translate('Bluemoon.Froala.Heading4'),
                $translate('Bluemoon.Froala.Heading5'),
                $translate('Bluemoon.Froala.Heading6'),
                $translate('Bluemoon.Froala.BlockStyle'),
                $translate('Bluemoon.Froala.Alignment'),
                $translate('Bluemoon.Froala.AlignLeft'),
                $translate('Bluemoon.Froala.AlignCenter'),
                $translate('Bluemoon.Froala.AlignRight'),
                $translate('Bluemoon.Froala.Justify'),
                $translate('Bluemoon.Froala.NumberedList'),
                $translate('Bluemoon.Froala.BulletedList'),
                $translate('Bluemoon.Froala.IndentLess'),
                $translate('Bluemoon.Froala.IndentMore'),
                $translate('Bluemoon.Froala.SelectAll'),
                $translate('Bluemoon.Froala.InsertLink'),
                $translate('Bluemoon.Froala.InsertImage'),
                $translate('Bluemoon.Froala.InsertVideo'),
                $translate('Bluemoon.Froala.Undo'),
                $translate('Bluemoon.Froala.Redo'),
                $translate('Bluemoon.Froala.ShowHtml'),
                $translate('Bluemoon.Froala.FloatLeft'),
                $translate('Bluemoon.Froala.FloatNone'),
                $translate('Bluemoon.Froala.FloatRight'),
                $translate('Bluemoon.Froala.ReplaceImage'),
                $translate('Bluemoon.Froala.RemoveImage'),
                $translate('Bluemoon.Froala.Title'),
                $translate('Bluemoon.Froala.DropImage'),
                $translate('Bluemoon.Froala.OrClick'),
                $translate('Bluemoon.Froala.Or'),
                $translate('Bluemoon.Froala.EnterUrl'),
                $translate('Bluemoon.Froala.PleaseWait'),
                $translate('Bluemoon.Froala.AreYouSure'),
                $translate('Bluemoon.Froala.Unlink'),
                $translate('Bluemoon.Froala.OpenNewTab'),
                $translate('Bluemoon.Froala.TypeSomething'),
                $translate('Bluemoon.Froala.Cancel'),
                $translate('Bluemoon.Froala.Ok'),
                $translate('Bluemoon.Froala.ManageImages'),
                $translate('Bluemoon.Froala.Delete'),
                $translate('Bluemoon.Froala.FontFamily'),
                $translate('Bluemoon.Froala.InsertHorizontalLine'),
                $translate('Bluemoon.Froala.Table'),
                $translate('Bluemoon.Froala.InsertTable'),
                $translate('Bluemoon.Froala.Cell'),
                $translate('Bluemoon.Froala.Row'),
                $translate('Bluemoon.Froala.Column'),
                $translate('Bluemoon.Froala.DeleteTable'),
                $translate('Bluemoon.Froala.InsertCellBefore'),
                $translate('Bluemoon.Froala.InsertCellAfter'),
                $translate('Bluemoon.Froala.DeleteCell'),
                $translate('Bluemoon.Froala.MergeCells'),
                $translate('Bluemoon.Froala.HorizontalSplit'),
                $translate('Bluemoon.Froala.VerticalSplit'),
                $translate('Bluemoon.Froala.InsertRowAbove'),
                $translate('Bluemoon.Froala.InsertRowBelow'),
                $translate('Bluemoon.Froala.DeleteRow'),
                $translate('Bluemoon.Froala.InsertColumnBefore'),
                $translate('Bluemoon.Froala.InsertColumnAfter'),
                $translate('Bluemoon.Froala.DeleteColumn'),
                $translate('Bluemoon.Froala.UploadingImage'),
                $translate('Bluemoon.Froala.UploadFile'),
                $translate('Bluemoon.Froala.DropFile'),
                $translate('Bluemoon.Froala.ClearFormatting'),
                $translate('Bluemoon.Froala.InsertLinkButton'),
                $translate('Bluemoon.Froala.Height'),
                $translate('Bluemoon.Froala.Width'),
                $translate('Bluemoon.Froala.TextColor'),
                $translate('Bluemoon.Froala.ButtonTextPlaceholder'),
                $translate('Bluemoon.Froala.ButtonLinkPlaceholder')
            ];
        }
    }])
    .config([function(){
        jquery.Editable.DEFAULTS.key = 'yc1VYJZa1c2a1THYBUZY==';
    }])
    .run(['bmFroalaTranslate', function(froalaTranslate){
        froalaTranslate.initFroalaLanguages();
    }]);
})(window.angular, window.jQuery);
